<div class="modal-wrapper">
	<div class="modal-header">
		<div class="modal-header-content">
			<h1 class="modal-title">Loading </h1>
		</div>
	</div>
	<div class="modal-body">
		<p>{{data}}</p>
	</div>
	<div class="modal-footer">
	</div>
</div>